import React, { Component } from 'react';
//import PropTypes from 'prop-types';

class EditCategoryView extends Component {

  render() {

    return (
      <div onClick={this.props.handleClick}>
        <img alt={this.props.name} src={this.props.icon_url} />
         <h3 className="category-text">{this.props.name}</h3>
      </div>
    )
  }
}

export default EditCategoryView;



// WEBPACK FOOTER //
// ./src/snapit_app/components/EditCategoryView.js